export var LongGameErrorCode;
(function (LongGameErrorCode) {
    LongGameErrorCode[LongGameErrorCode["BadRequest"] = 40000] = "BadRequest";
    LongGameErrorCode[LongGameErrorCode["Unauthorized"] = 40100] = "Unauthorized";
    LongGameErrorCode[LongGameErrorCode["SessionExpired"] = 40101] = "SessionExpired";
    LongGameErrorCode[LongGameErrorCode["SessionInvalid"] = 40102] = "SessionInvalid";
    LongGameErrorCode[LongGameErrorCode["Forbidden"] = 40300] = "Forbidden";
    LongGameErrorCode[LongGameErrorCode["NotFound"] = 40400] = "NotFound";
    LongGameErrorCode[LongGameErrorCode["Conflict"] = 40900] = "Conflict";
    LongGameErrorCode[LongGameErrorCode["InternalServerError"] = 50000] = "InternalServerError";
    LongGameErrorCode[LongGameErrorCode["Unknown"] = 0] = "Unknown";
})(LongGameErrorCode || (LongGameErrorCode = {}));
export class LongGameError extends Error {
    code;
    static Code = LongGameErrorCode;
    name = 'LongGameError';
    response;
    static isInstance = (err) => {
        if (err instanceof LongGameError)
            return true;
        if (err instanceof Error && err.name === 'LongGameError')
            return true;
        return false;
    };
    static isRpcInstance = (err) => {
        if (typeof err === 'object' &&
            err.name === 'Error' &&
            !!err.message &&
            err.message.startsWith('LongGameError: '))
            return true;
        return false;
    };
    static fromInstanceOrRpc = (err) => {
        if (LongGameError.isInstance(err))
            return err;
        if (err &&
            err instanceof Error &&
            'code' in err &&
            typeof err.code === 'number') {
            return new LongGameError(err.code, err.message);
        }
        if (err && err instanceof Error) {
            const code = /\(code: (\d+)\)/.exec(err.message);
            if (code) {
                return new LongGameError(Number(code[1]), err.message);
            }
        }
        return new LongGameError(LongGameErrorCode.Unknown, String(err));
    };
    static fromResponse = (res) => {
        if (res.ok) {
            return null;
        }
        const code = Number(res.headers.get('X-Long-Game-Error')) || 0;
        const message = res.headers.get('X-Long-Game-Message') || 'Unknown error';
        return new LongGameError(code, message, res);
    };
    static throwIfError = (res) => {
        const error = LongGameError.fromResponse(res);
        if (error) {
            throw error;
        }
    };
    static wrap = (err) => {
        if (LongGameError.isInstance(err)) {
            return err;
        }
        if (err instanceof Error) {
            return new LongGameError(LongGameErrorCode.Unknown, err.message, err);
        }
        return new LongGameError(LongGameErrorCode.Unknown, 'An unexpected error occurred', err);
    };
    constructor(code, message, cause) {
        // @ts-ignore
        super(message ? `${message}` : `Error (code: ${code})`, {
            cause,
        });
        this.code = code;
        this.name = 'LongGameError';
        this.code = code;
        if (cause instanceof Response) {
            this.response = cause;
        }
    }
    get statusCode() {
        if (this.code === 0) {
            return 500;
        }
        return Math.floor(this.code / 100);
    }
    get body() {
        return { code: this.code, message: this.message };
    }
    get headers() {
        return {
            'X-Long-Game-Error': this.code.toString(),
            'X-Long-Game-Message': this.message,
        };
    }
    toResponse = () => new Response(JSON.stringify(this.body), {
        status: this.statusCode,
        headers: {
            'Content-Type': 'application/json',
            ...this.headers,
        },
    });
    toLogs = async () => [
        `LongGameError: ${this.message} (code: ${this.code})`,
        ...(this.response
            ? [
                `Response status: ${this.response.status}`,
                `Response body: ${this.response.bodyUsed ? '[used]' : await this.response.text()}`,
            ]
            : []),
        ...(this.stack ? [this.stack] : []),
    ];
    toLogsSync = () => [
        `LongGameError: ${this.message} (code: ${this.code})`,
        ...(this.stack ? [this.stack] : []),
    ];
}
//# sourceMappingURL=error.js.map